import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {Cart} from '@spartacus/cart/base/root';
import {EddlMergedAbstract} from './../events/eddl-merged.abstract';

export class EddlAddToCartEvent extends EddlMergedAbstract {
  static readonly type = 'EddlAddToCartEvent';
  entry?: OrderEntry;
  productCode?: string;
  cart?: Cart;
}
